<script lang="ts">
	import { onMount } from 'svelte';
	import { browser } from '$app/environment';
	import { fade } from 'svelte/transition';

	let isVisible = $state(false);
	let scrollThreshold = 300;

	onMount(() => {
		if (!browser) return;

		const handleScroll = () => {
			isVisible = window.scrollY > scrollThreshold;
		};

		// Throttle pour optimiser les performances
		let ticking = false;
		const throttledScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					handleScroll();
					ticking = false;
				});
				ticking = true;
			}
		};

		window.addEventListener('scroll', throttledScroll, { passive: true });

		return () => {
			window.removeEventListener('scroll', throttledScroll);
		};
	});

	const scrollToTop = () => {
		if (!browser) return;

		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};
</script>

{#if isVisible}
	<button
		onclick={scrollToTop}
		class="fixed right-6 bottom-6 z-50 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-juslin-blue text-juslin-white shadow-lg transition-all duration-300 hover:scale-110 hover:bg-juslin-blue/90 hover:shadow-xl hover:shadow-juslin-blue/30 active:scale-95 lg:right-8 lg:bottom-8"
		aria-label="Retour en haut"
		transition:fade={{ duration: 200 }}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="h-6 w-6"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			stroke-width="2"
		>
			<path stroke-linecap="round" stroke-linejoin="round" d="M5 10l7-7m0 0l7 7m-7-7v18" />
		</svg>
	</button>
{/if}
